import { useState, useEffect, useCallback, useRef } from "react";
import { useCreateBillsMutation, useControllBillsMutation } from "../store";

export default function useBillOperationData(token) {
  const [alert, setAlert] = useState(0);
  const [message, setMessage] = useState("");
  const [state, setState] = useState(0);
  const alertTimerRef = useRef(null);

  const [create, resultCreate] = useCreateBillsMutation();
  const [controll, resultControll] = useControllBillsMutation();

  const showAlert = useCallback((type, msg) => {
    setAlert(type);
    setMessage(msg);
  }, []);

  useEffect(() => {
    if (alert !== 0) {
      if (alertTimerRef.current) clearTimeout(alertTimerRef.current);
      alertTimerRef.current = setTimeout(() => {
        setAlert(0);
        setMessage("");
      }, 5000);
    }
    return () => {
      if (alertTimerRef.current) clearTimeout(alertTimerRef.current);
    };
  }, [alert]);

  useEffect(() => {
    if (resultCreate.isError) {
      showAlert(2, resultCreate.error?.data?.message || "Hata oluştu");
    } else if (resultCreate.isSuccess) {
      showAlert(1, "Faturalar Tanımlandı!");
    }
  }, [resultCreate.isSuccess, resultCreate.isError, resultCreate.error, showAlert]);

  useEffect(() => {
    if (resultControll.isError) {
      showAlert(2, resultControll.error?.data?.message || "Hata oluştu");
    } else if (resultControll.isSuccess) {
      showAlert(1, "Fatura Kontrolü Yapıldı!");
    }
  }, [resultControll.isSuccess, resultControll.isError, resultControll.error, showAlert]);

  const HandleUpload = useCallback(() => {
    const validBills = resultControll.data?.bills?.filter((item) => item.status) || [];
    setState(2);
    create({ bills: validBills, token });
  }, [resultControll.data, create, token]);

  const sortData = useCallback((data, sortConfig) => {
    if (!sortConfig.key) return data;
    return [...data].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key])
        return sortConfig.direction === "ascending" ? -1 : 1;
      if (a[sortConfig.key] > b[sortConfig.key])
        return sortConfig.direction === "ascending" ? 1 : -1;
      return 0;
    });
  }, []);

  return {
    alert,
    message,
    state,
    setState,
    create,
    resultCreate,
    controll,
    resultControll,
    HandleUpload,
    sortData,
  };
}
